import React from 'react';

export default (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM11.91 6.14685L10.6485 4.89587L6.91094 8.60224L5.35135 7.05558L4.08984 8.30655L6.91093 11.1042L11.91 6.14685Z" fill="#23B036" />
  </svg>
);
